import { LootRule } from "./lootRule";
import { LootTable } from "./lootTable";
import { MissileGun } from "../weapons/missileGun.ts";
import { Cannon } from "../weapons/cannon.ts";
import { LandmineWeapon } from "../weapons/landmineWeapon.ts";
import { CannonBurst } from "../weapons/cannonBurst.ts";
import { Flamethrower } from "../weapons/flamethrower.ts";
import { LaserGun } from "../weapons/laserGun.ts";
import { DrillLauncher } from "../weapons/drillLauncher.ts";
import { PlasmaGun } from "../weapons/plasmaGun.ts";

function r(level: number, weaponKey: string, ammo: number): LootRule;
function r(level: number, weaponKey: string, ammoMin: number, ammoMax: number): LootRule;
function r(levelMin: number, levelMax: number, weaponKey: string, ammo: number): LootRule;
function r(levelMin: number, levelMax: number, weaponKey: string, ammoMin: number, ammoMax: number): LootRule;
function r(...args: any[]): LootRule {
	if (args.length === 3) {
		// r(level, weaponKey, ammo)
		return new LootRule(args[0], args[0], args[1], args[2], args[2]);
	} else if (args.length === 4) {
		if (typeof args[1] === "string") {
			// r(level, weaponKey, ammoMin, ammoMax)
			return new LootRule(args[0], args[0], args[1], args[2], args[3]);
		} else {
			// r(levelMin, levelMax, weaponKey, ammo)
			return new LootRule(args[0], args[1], args[2], args[3], args[3]);
		}
	} else {
		// r(levelMin, levelMax, weaponKey, ammoMin, ammoMax)
		return new LootRule(args[0], args[1], args[2], args[3], args[4]);
	}
}

export class ProdLootTable {
	static getWastelandLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, "Cannon", 10));

		t.addRule(r(2, "Cannon", 10));
		t.addRule(r(2, "LandmineWeapon", 5));

		t.addRule(r(3, "Cannon", 10));
		t.addRule(r(3, "LandmineWeapon", 5));

		// rest area
		t.addRule(r(4, "Cannon", 10));
		t.addRule(r(4, "LandmineWeapon", 5));

		t.addRule(r(5, "Cannon", 10));
		t.addRule(r(5, "LandmineWeapon", 5));
		t.addRule(r(5, "CannonBurst", 3));

		t.addRule(r(6, "Cannon", 10));
		t.addRule(r(6, "LandmineWeapon", 5));
		t.addRule(r(6, "MissileGun", 1));
		t.addRule(r(6, "CannonBurst", 3));

		// robot fortress level
		t.addRule(r(7, "Cannon", 15));
		t.addRule(r(7, "LandmineWeapon", 5));
		t.addRule(r(7, "MissileGun", 1));
		t.addRule(r(7, "CannonBurst", 5));

		t.addRule(r(8, "Cannon", 15));
		t.addRule(r(8, "LandmineWeapon", 7));
		t.addRule(r(8, "MissileGun", 1));
		t.addRule(r(8, "CannonBurst", 5));

		t.addRule(r(9, "Cannon", 15));
		t.addRule(r(9, "LandmineWeapon", 7));
		// t.addRule(r(9, "DrillLauncher", 2));
		t.addRule(r(9, "MissileGun", 2));
		t.addRule(r(9, "CannonBurst", 5));

		t.addRule(r(10, "Cannon", 15));
		t.addRule(r(10, "LandmineWeapon", 7));
		// t.addRule(r(10, "DrillLauncher", 2));
		t.addRule(r(10, "MissileGun", 2));
		t.addRule(r(10, "CannonBurst", 5));

		return t;
	}

	// Reward level == cave number (1–6). Two tiers: early (1–2) and mid (3+).
	// The last cave (6) uses the same mid-tier per-box loot; its extra supply
	// comes from more boxes (set in getCaveLevel), not richer boxes.
	static getCaveLootTable(): LootTable {
		const t = new LootTable();

		// Early caves (1–2)
		t.addRule(r(1, 2, Cannon.key, 20));
		t.addRule(r(1, 2, LandmineWeapon.key, 10));
		t.addRule(r(1, 2, MissileGun.key, 2));
		t.addRule(r(1, 2, CannonBurst.key, 5));

		// Mid caves (3+, includes the last cave)
		t.addRule(r(3, 999, Cannon.key, 25));
		t.addRule(r(3, 999, LandmineWeapon.key, 10));
		t.addRule(r(3, 999, MissileGun.key, 2));
		t.addRule(r(3, 999, CannonBurst.key, 5));

		return t;
	}

	static getRobotBaseLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(0, 999, Cannon.key, 10));
		t.addRule(r(0, 999, LandmineWeapon.key, 10));
		t.addRule(r(0, 999, MissileGun.key, 5));
		t.addRule(r(0, 999, CannonBurst.key, 5));

		return t;
	}

	// Metal loot tables that have better loot

	static getWastelandMetalLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, "Cannon", 10));
		t.addRule(r(1, "LandmineWeapon", 10));

		t.addRule(r(2, "MissileGun", 2));

		t.addRule(r(3, "LaserGun", 1));
		t.addRule(r(3, "MissileGun", 2));

		t.addRule(r(4, "LaserGun", 2));
		t.addRule(r(4, "Flamethrower", 1));
		t.addRule(r(4, "MissileGun", 2));
		t.addRule(r(4, "CannonBurst", 2));

		t.addRule(r(5, "LaserGun", 2));
		t.addRule(r(5, "Flamethrower", 1));
		t.addRule(r(5, "MissileGun", 2));
		t.addRule(r(5, "CannonBurst", 2));

		t.addRule(r(6, "LaserGun", 2));
		t.addRule(r(6, "Flamethrower", 2));
		t.addRule(r(6, "MissileGun", 3));
		t.addRule(r(6, "CannonBurst", 3));

		t.addRule(r(7, "LaserGun", 2));
		t.addRule(r(7, "Flamethrower", 2));
		t.addRule(r(7, "MissileGun", 4));
		t.addRule(r(7, "CannonBurst", 4));
		t.addRule(r(7, "DrillLauncher", 4));

		t.addRule(r(8, "LaserGun", 2));
		t.addRule(r(8, "Flamethrower", 2));
		t.addRule(r(8, "MissileGun", 4));
		t.addRule(r(8, "CannonBurst", 4));
		t.addRule(r(8, "DrillLauncher", 4));

		t.addRule(r(9, "LaserGun", 2));
		t.addRule(r(9, "Flamethrower", 2));
		t.addRule(r(9, "MissileGun", 4));
		t.addRule(r(9, "CannonBurst", 4));
		t.addRule(r(9, "DrillLauncher", 4));

		t.addRule(r(10, 999, "LaserGun", 15));
		t.addRule(r(10, 999, "Flamethrower", 10));
		t.addRule(r(10, 999, "MissileGun", 15));
		// t.addRule(r(10, 999, "GasBombWeapon", 4));
		t.addRule(r(10, 999, "CannonBurst", 10));
		t.addRule(r(10, 999, "DrillLauncher", 15));

		return t;
	}

	static getCaveMetalLootTable(): LootTable {
		const t = new LootTable();
		t.addRule(r(1, 999, LaserGun.key, 4));
		t.addRule(r(1, 999, Flamethrower.key, 2));
		t.addRule(r(1, 999, MissileGun.key, 5));
		// t.addRule(r(1, 999, CannonBurst.key, 5));
		t.addRule(r(1, 999, DrillLauncher.key, 10));

		return t;
	}

	static getRobotBaseMetalLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(0, 999, MissileGun.key, 10));
		t.addRule(r(0, 999, PlasmaGun.key, 10));
		t.addRule(r(0, 999, LaserGun.key, 10));

		return t;
	}

	// Power plant branch (levels 1000, 1001). Reward level is the index within the branch.
	static getPowerPlantLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, Cannon.key, 10));
		t.addRule(r(2, Cannon.key, 15));

		return t;
	}

	static getPowerPlantMetalLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, MissileGun.key, 5));
		t.addRule(r(1, PlasmaGun.key, 2));

		t.addRule(r(2, MissileGun.key, 5));
		t.addRule(r(2, PlasmaGun.key, 5));

		return t;
	}

	// Power plant underground branch (levels 2000, 2001). Reward level is the index within the branch.
	static getPowerPlantUndergroundLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, Cannon.key, 20));

		t.addRule(r(2, Cannon.key, 20));

		return t;
	}

	static getPowerPlantUndergroundMetalLootTable(): LootTable {
		const t = new LootTable();

		t.addRule(r(1, MissileGun.key, 10));

		t.addRule(r(2, MissileGun.key, 10));

		return t;
	}
}
